module.exports = __webpack_public_path__ + "img/12.203226a4.jpg";